import { Routes } from 'constants/pages';
import _ from 'lodash';
import { User } from 'types/User';
import { checkForPermission, Permission } from 'utils/permissions';

export interface BannerDefinition {
  id: string;
  type: 'warning' | 'alert';
  style?: React.CSSProperties;
  startCopy?: string;
  middleCopy?: string | ((user: User) => string);
  endCopy?: string;
  path?: string;
  link?: string;
  href?: string;
  shouldBeDisplayed: (user: User, credentialsValid: boolean, permissions: Permission[]) => boolean;
}

export const BANNERS: BannerDefinition[] = [
  {
    id: 'credentials-banner',
    type: 'warning',
    startCopy: 'Please',
    shouldBeDisplayed: (user, allCredentialsEnteredAndValid, permissions) =>
      !allCredentialsEnteredAndValid &&
      !!user?.company?.has_scac &&
      checkForPermission([Permission.TerminalCredentials], permissions),
    link: 'enter your credentials ',
    endCopy: 'to unleash the full potential of BlueCargo',
    path: Routes.Credentials,
  },
  {
    type: 'warning',
    id: 'freetrial-banner',
    shouldBeDisplayed: (user) => !_.isNil(user.freeTrialRemainingDays),
    startCopy: 'You have',
    middleCopy: (user) => ` ${user.freeTrialRemainingDays} days left in your free trial. Please `,
    link: 'upgrade your subscription',
    endCopy: ' to continue using all features!',
    path: Routes.Plans,
  },
  {
    type: 'alert',
    id: 'container-limit-banner',
    shouldBeDisplayed: (user) => user.containerCreditsLimitReached,
    startCopy: 'Your company has reached its total allowed tracked containers.',
    link: 'Add containers to your company plan now!',
    endCopy: '',
    path: Routes.Plans,
  },
  // TODO: these two banners are identical, we could refactor it and make the type attribute a function
  {
    type: 'warning',
    id: 'payment-failed',
    shouldBeDisplayed: (user) => _.get(user, 'company.subscription_status') === 'past_due',
    startCopy: 'Your payment method has failed.  Please update your payment method',
    link: 'here',
    endCopy: 'to continue using BlueCargo.',
    path: Routes.InvoiceHistory,
  },
  {
    type: 'alert',
    id: 'payment-failed',
    shouldBeDisplayed: (user) => _.get(user, 'company.subscription_status') === 'unpaid',
    startCopy: 'Your payment method has failed. Please update your payment method',
    link: 'here',
    endCopy: 'to continue using BlueCargo.',
    path: Routes.InvoiceHistory,
  },
];
